/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
//
// Discussion specific UI bindings.
//
$(document).on("turbo:load", function () {
  // Use mustache template formatting for underscore templates
  _.templateSettings.interpolate = /{{([\s\S]+?)}}/g

  // Frontend UI events
  // ------------------------
  //
  return $("#discuss")
    .on("click", "[data-behavior=submit-response]", function (e) {
      // Block submit if comment field is empty.
      const $commentField = $(this)
        .closest("form")
        .find("[data-input-field='response']")
      if (!$.trim($commentField.val())) {
        e.preventDefault()
        return alert("Comment cannot be blank.")
      }
    })
    .on("click", "[data-behavior=cancel-form]", function (e) {
      // hide comment form
      e.preventDefault()
      $(this).closest("[data-cancel-form]").remove()
      $("#discuss").find(".join").removeClass("hide")
      return $(".oratorStart").show()
    })
    .on("click", "[data-behavior=submit-discussion]", function (e) {
      // Block submit if discussion title is empty.
      const $titleField = $(this)
        .closest("form")
        .find("[data-input-field='title']")
      if (!$.trim($titleField.val())) {
        e.preventDefault()
        return alert("Discussion title cannot be blank.")
      }
    })
})
